import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col, Button } from 'reactstrap';

import { callApi } from '../../utils';
import { showError } from '../../actions/notificationActions';
import CreatePromotionModal from '../CreatePromotionModal';

import SearchForm from '.././SearchForm';
import { openCreatePromotionModal } from '../../actions/modalActions';
import DataTable, { PageHeader } from '../DataTable';

class List extends Component {
  state = {
    rows: [],
    query: '',
    page: 1,
    limit: 300,
    loading: false,
    pages: 1,
  };

  componentWillMount() {
    this.loadGateways();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadGateways = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, page, limit } = this.state;

    this.startLoad();
    callApi(`/promotions?q=${query}&page=${page}&limit=${limit}`)
      .then(({ data = [], meta = {} }) => {
        this.setState({ loading: false, rows: data, pages: meta.pages });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadGateways();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  openTransaction = (id) => {
    // this.props.dispatch(openTransactionModal({id}));
    this.props.history.push(`/promotions/${id}`);
  };

  refresh = () => {
    window.location.reload();
  };

  render() {
    const { query, rows, page, loading, limit, pages } = this.state;

    const hasResults = rows.length > 0;
    return (
      <div className="container-fluid">
        <CreatePromotionModal refresh={this.refresh} />

        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="Promotions"
              subtitle={<>Promotions - Page {page}</>}
            >
              <Button
                // size="sm"
                // disabled={}
                color={'primary'}
                onClick={() => {
                  this.props.dispatch(openCreatePromotionModal());
                }}
              >
                Create Promotion
              </Button>
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.loadGateways}
                loading={loading}
              />
            </PageHeader>

            <DataTable
              minWidth={800}
              loading={loading}
              page={page}
              total={pages || 1}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Name</th>
                  <th>Active</th>
                  <th>Applies To</th>
                  <th>Description</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((t, i) => (
                  <tr onClick={() => this.openTransaction(t.id)} key={t.id}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{t.label}</td>
                    <td>{t.open ? 'YES' : 'NO'}</td>
                    <td style={{}}>{t.applies_to}</td>
                    <td style={{ width: '50%' }}>{t.description}</td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(List);
